import dashboard from '@/modules/dashboard/views/index.vue';


let sub_step_roles = {
  ADMIN: ['monthlypayroll','monthlypayroll1', 'incometax', 'employees', 'fbpPayroll','incometaxdeclarationplan', 'incometaxproofplan', 'utilities', 'perquisites', 'changePasswordUser'],
  EMPLOYEE: ['feed','dashboard', 'payrollReports', 'itDeclarationDashboard', 'itDeclaration', 'changePasswordUser'],
  SUPERADMIN: ['monthlypayroll','monthlypayroll1', 'incometax', 'employees', 'fbpPayroll','incometaxdeclarationplan', 'incometaxproofplan', 'utilities', 'perquisites', 'changePasswordUser'],
  AUDITOR: ['changePasswordUser','incometaxaudit'],
  TEAMLEADER: ['monthlypayroll','monthlypayroll1', 'incometax', 'employees', 'fbpPayroll','incometaxdeclarationplan', 'incometaxproofplan', 'utilities', 'perquisites', 'changePasswordUser'],
  ANCHOR: ['changePasswordUser'],
  CLIENTADMIN: ['feed','dashboard', 'payrollReports', 'itDeclarationDashboard', 'itDeclaration', 'changePasswordUser']
}
let step_name_roles = {
  ADMIN: ['stdReport', 'payroll', 'payslipItSheet'],
  EMPLOYEE: ['mysalary', 'myProfile', 'fbpDeclarationEss', 'fbpClaimsEss',],
  SUPERADMIN: [],
  AUDITOR: [],
  TEAMLEADER: [],
  ANCHOR: [],
  CLIENTADMIN: ['payslipItSheet', 'stdReport', 'mysalary', 'myProfile', 'fbpDeclarationEss', 'fbpClaimsEss', 'essResetPassword', 'letterManagement']
}
let sub_step_name_roles = {
  ADMIN: ['myReports'],
  EMPLOYEE: [],
  SUPERADMIN: [],
  AUDITOR: [],
  TEAMLEADER: [],
  ANCHOR: [],
  CLIENTADMIN: ['']
}

import logSheetHomePage from './views/pages/logSheet/logSheetHome.vue'
const routes = [
  {
    path: "/dashboard/logsheet",
    component: logSheetHomePage
  },
  {
    path: "/dashboard/:entity_index/directPay/hsbcDirectPay",
    redirect:  "/dashboard/:entity_index/hsbcAccounts/paymentInitiate",
    props: route => ({ entity_index: route.params.entity_index })
  },
  {
    path: "/dashboard/:entity_index/overview",
    // redirect: (localStorage.getItem("userRole") == "TEAMLEADER" || localStorage.getItem("userRole") == "ANCHOR"|| localStorage.getItem("userRole") == "SUPERADMIN"|| localStorage.getItem("userRole") == "ADMIN") ?
    // "/dashboard/:entity_index/payroll/monthlypayroll" : "/dashboard/:entity_index/overview/feed",
    redirect: "/dashboard/:entity_index/overview/feed",
    props: route => ({ entity_index: route.params.entity_index })
  },

  {
    path: "/dashboard/:entity_index/mysalary",
    redirect: (localStorage.getItem("userRole") == "TEAMLEADER" || localStorage.getItem("userRole") == "ANCHOR"|| localStorage.getItem("userRole") == "SUPERADMIN"|| localStorage.getItem("userRole") == "ADMIN") ?
    "/dashboard/:entity_index/payroll/monthlypayroll" : "/dashboard/:entity_index/mysalary/payrollReports",
    //redirect: "/dashboard/:entity_index/payroll/monthlypayroll",
    props: route => ({ entity_index: route.params.entity_index })
  },
  {
     path: "/dashboard/:entity_index/incomeTax",
     redirect:"/dashboard/:entity_index/incomeTax/itProofSubmission",
     props: route=>({entity_index: route.params.entity_index})
  },
  {
    path: "/dashboard/:entity_index/hsbcAccountSettings",
    redirect:  "/dashboard/:entity_index/hsbcAccountSettings/accountPageHsbc",
    props: route => ({ entity_index: route.params.entity_index })
  },
  
  {
    path: "/dashboard/:entity_index/payroll",
    redirect: "/dashboard/:entity_index/payroll/monthlypayroll",
    props: route => ({ entity_index: route.params.entity_index })
  },
  {
    path: "/dashboard/:entity_index/payroll",
    redirect: "/dashboard/:entity_index/payroll/monthlypayroll",
    props: route => ({ entity_index: route.params.entity_index })
  },
  {
    path: "/dashboard/:entity_index/myteam",
    redirect: "/dashboard/:entity_index/myteam/reportees",
    props: route => ({ entity_index: route.params.entity_index })
  },
  {
    path: "/dashboard/:entity_index/organisation",
    redirect:(localStorage.getItem("userRole") == "TEAMLEADER" || localStorage.getItem("userRole") == "ANCHOR"|| localStorage.getItem("userRole") == "SUPERADMIN"|| localStorage.getItem("userRole") == "ADMIN") ?
    "/dashboard/:entity_index/organisation/employees" : "/dashboard/:entity_index/organisation/utilities",
    props: route => ({ entity_index: route.params.entity_index })
  },
  {
    path: "/dashboard/:entity_index/reports",
    redirect: "/dashboard/:entity_index/reports/reportsDashboard/myReports",
    props: route => ({ entity_index: route.params.entity_index })
  },
  {
    path: "/dashboard/:entity_index/settings",
    redirect: "/dashboard/:entity_index/settings/orgDetails",
    props: route => ({ entity_index: route.params.entity_index })
  },
  {
    path: "/dashboard/:entity_index/:step_name/:sub_step",
    component: dashboard,
    name: "dashboardSubstep",
    props: route => ({
      step_name: route.params.step_name,
      sub_step: route.params.sub_step,
      entity_index: route.params.entity_index
    }),
    beforeEnter: (to, from, next) => {
      // Check if the user is authenticated
      // if (!isAuthenticated()) {
      //   // If not authenticated, redirect to the login page or a page with access denied message
      //   next("/login"); // Replace "/login" with the appropriate route for login
      //   return;
      // }

      // Check if the user has the required role to access the route
      // const requiredRoles = roles[to.params.step_name.toUpperCase()];
      // if (!requiredRoles || !requiredRoles.includes(localStorage.getItem("userRole"))) {
      //   // If the user does not have the required role, redirect to a page with access denied message
      //   next("/access-denied"); // Replace "/access-denied" with the appropriate route for access denied message
      //   return;
      // }

      // // If the user is authenticated and has the required role, allow navigation to the route
      // next();
      let userRole = window.localStorage.getItem('userRole');
      // if(tokenAvailable()) {
        const requiredRoles = sub_step_roles[userRole];
        const authRoles = requiredRoles.find((element) => {
          if(element === to.params.sub_step){
            return true;
          }
        })
        if (false) {
          // If the user does not have the required role, redirect to a page with access denied message
          next("/restricted"); // Replace "/access-denied" with the appropriate route for access denied message
          return;
        }
  
        // If the user is authenticated and has the required role, allow navigation to the route
        next();
      // } else {
      //   next({path: '/signin', query: {entry_url: to.path}});
      // }
    },
  },
  {
    path: "/dashboard/:entity_index/:step_name/:sub_step/:sub_step_name",
    component: dashboard,
    name: "dashboardSubstepname",
    props: route => ({
      step_name: route.params.step_name,
      sub_step: route.params.sub_step,
      sub_step_name: route.params.sub_step_name,
      entity_index: route.params.entity_index
    }),
    beforeEnter: (to, from, next) => {
      let userRole = window.localStorage.getItem('userRole');
      if (userRole == 'ADMIN' || userRole == 'TEAMLEADER' || userRole == 'SUPERADMIN'|| userRole == 'AUDITOR') {
        next();
        return;
      }
      next("/restricted");
    },
  },
  {
    path: "/dashboard/:entity_index/:step_name",
    component: dashboard,
    name: "dashboard",
    props: route => ({ step_name: route.params.step_name, entity_index: route.params.entity_index }),
    beforeEnter: (to, from, next) => {
        let userRole = window.localStorage.getItem('userRole');
        const requiredRoles = step_name_roles[userRole];
        const authRoles = requiredRoles.find((element) => {
          if(element === to.params.step_name){
            return true;
          }
        })
        if (!authRoles) {
          // If the user does not have the required role, redirect to a page with access denied message
          next("/restricted"); // Replace "/access-denied" with the appropriate route for access denied message
          return;
        }
        next();
    },
  },

];

export default routes;
